export class ScanAndAttachModel {
  readonly type: string = 'ScanAndAttach'

  SendMail: string = ''
  Mailserver: string = ''
  Port: string = ''
  EnableSSL: string = ''
  SenderAddress: string = ''
  MailUsername: string = ''
  MailPassword: string = ''
  TestConnection: string = ''
  SourceFolder: string = ''
  ManualSourceFolder: string = ''
  InProgressFolder: string = ''
  TargetFolder: string = ''
  ErrorFolder: string = ''
  ArchiveFolder: string = ''
  ErrorMails: string = ''
}

